import data from '../components/serviceDescription.json';
import messages from './services.en.json';

const sharedFields = new Set(['image', 'images', 'backGround', 'type', 'position']);
function translateContent(value, key) {
    if (sharedFields.has(key)) return value;
    if (typeof value === 'string') return messages[value] || value;
    if (Array.isArray(value)) return value.map(item => translateContent(item));
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([field, item]) => [field, translateContent(item, field)]));
    }
    return value;
}

const englishData = Object.fromEntries(Object.entries(data).map(([key, service]) => {
    const translated = translateContent(service);
    translated.content.forEach((block, index) => {
        if (block.serviceOptions) {
            block.serviceOptions.data.forEach((item, itemIndex) => {
                // Keep the original service name in CRM requests; translate only its display label.
                item.requestName = service.content[index].serviceOptions.data[itemIndex].text;
            });
        }
    });
    return [key, translated];
}));

export function getServiceDescription(key, english) {
    return (english ? englishData : data)[key];
}
